"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function LogoIcon(props) {
    return (jsx_runtime_1.jsxs("svg", __assign({}, props, { viewBox: "0 0 65 88" }, { children: [jsx_runtime_1.jsx("circle", { cx: "11.52", cy: "11.52", r: "11.52" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "53.49", cy: "11.52", r: "11.52" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "11.52", cy: "52.78", r: "11.52" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "53.49", cy: "52.78", r: "11.52" }, void 0),
            jsx_runtime_1.jsx("path", { transform: "translate(-393.75 -467.67)", d: "M429.48,510.5a11.51,11.51,0,1,0-6.68,0c-2.67,41.22-28.09,36.57-28.09,36.57v8.63h62.86v-8.63S432.16,551.72,429.48,510.5Z" }, void 0)] }), void 0));
}
exports.default = LogoIcon;
//# sourceMappingURL=LogoIcon.js.map